import React from "react";
import Button from "../..//Elements/Button/Button.js";
import JumboPayProcessModal from "./JumboPayProcessModal.js";
import JumboPayProcessContainer from "./JumboPayProcessContainer.js";
import Image from "../../Elements/Image/Image.tsx";
import { useMail } from "../../../contexts/mailContext/mailContext.js";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { currencies } from "../../../utils/gridHelpers.js";
import { LinkToNewTab } from "../../Elements/Link/Link.js";

import "./JumboPayModal.scss";

const JumboPayModal = ({ paymentData, mailId }) => {
  const { setModal } = useModal();
  const { replaceKeywordsInText, getTextByKey, getHtmlByKey } = useContent();
  const currency = {
    nis: <span>&#x20aa;</span>,
    usd: <span>&#36;</span>,
    eur: <span>&#128;</span>,
  };
  const mailContext = useMail();
  if (!mailContext) return <></>;
  const { getPaymentData, getMailId, getSender } = mailContext;
  paymentData = getPaymentData();
  mailId = getMailId();

  return (
    <div className="modal-payment">
      <div className="payment-header">{getHtmlByKey("payment-request")}</div>
      <div className="payment-content">
        <div className="payment-explaining-one">
          {replaceKeywordsInText(
            getHtmlByKey("jumbopay-payment-requested-text"),
            ["#senderEmail#"],
            [getSender().email]
          )}
        </div>
        <div className="payment-info">
          <Image name="pigbank" />
          <div>
            <span className="small-font"></span>
            <span>
              {paymentData.Price.toString().replace(
                /\B(?=(\d{3})+(?!\d))/g,
                ","
              )}
            </span>
            <span className="small-font">
              {currencies[paymentData.Currency]}
            </span>
          </div>
        </div>
        <div className="payment-explaining-two">
          <p>
            {replaceKeywordsInText(
              getHtmlByKey("jumbopay-payment-explanation"),
              ["#senderDisplayName#"],
              [paymentData.DisplayName]
            )}
          </p>
        </div>
      </div>
      <div className="payment-footer">
        <Button
          title={getTextByKey("go-to-payment")}
          onClick={() => {
            window.dataLayer.push({
              event: "add_to_cart",
              ecommerce: {
                currency: currencies[paymentData.Currency],
                items: [
                  {
                    item_name: "Jumbo pay reciepent",
                    item_id: "6",
                    price: paymentData.Price,
                    quantity: "1",
                  },
                ],
              },
            });

            setModal({
              modal: JumboPayProcessModal,
              container: JumboPayProcessContainer,
            });
          }}
        />
        <div className="external-link">
          <LinkToNewTab isNewTab={true} page={`jumbo-pay`}>
            {getTextByKey("jumbopay-modal-how-does-it-work")}
          </LinkToNewTab>
        </div>
      </div>
    </div>
  );
};

export default JumboPayModal;
